import { useCallback, useEffect, useState } from 'react';

const KEY = 'zl_buyer_location';
const MAX_AGE_MS = 30 * 60 * 1000;

export const getCachedBuyerLocation = () => {
  try {
    const c = JSON.parse(localStorage.getItem(KEY));
    return c && Date.now() - c.ts < MAX_AGE_MS ? c : null;
  } catch { return null; }
};

export default function useBuyerLocation() {
  const [location, setLocation] = useState(getCachedBuyerLocation);
  const [status, setStatus] = useState(location ? 'granted' : 'idle');

  const request = useCallback(() => {
    if (!navigator.geolocation) { setStatus('unavailable'); return; }
    setStatus('asking');
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const loc = { lat: pos.coords.latitude, lng: pos.coords.longitude, ts: Date.now() };
        localStorage.setItem(KEY, JSON.stringify(loc));
        setLocation(loc);
        setStatus('granted');
      },
      () => setStatus('denied'),
      { timeout: 8000, maximumAge: 10 * 60 * 1000 }
    );
  }, []);

  useEffect(() => { if (!location) request(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return { location, status, request };
}
